import React, { useState } from 'react';
import {
  Box,
  Heading,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Text,
  VStack,
} from '@chakra-ui/react';
import { Navigate, useSearchParams } from 'react-router-dom';
import { BotsTab } from './tabs/BotsTab';
import { LogsBrowserView } from '../analiseBots/components/LogsBrowserView';

/**
 * Automação — cadastro/credenciais dos bots (aba Bots) e navegador de logs (aba Logs).
 *
 * As abas de acompanhamento antigas (Operação, Análise/dashboards e Empresas) foram
 * substituídas pela tela /orquestrador (Processos/Resumo/Dependências), e a aba
 * Gerenciar Logs saiu junto com a governança de logs do backend. Bookmarks antigos
 * dessas abas (`?secao=operacao`, `?secao=analise` sem `tab=logs`) redirecionam para
 * o /orquestrador; os do navegador de logs (`?secao=analise&tab=logs`,
 * `?secao=gerenciar-logs`) caem na aba Logs.
 */

const ABAS: readonly string[] = ['bots', 'logs'];

/** Traduz `?secao=`/`?tab=` (inclusive os valores legados) para a aba viva ou redirect. */
const resolveSecao = (secao: string | null, tab: string | null): string => {
  if (secao === 'operacao') return 'orquestrador';
  if (secao === 'analise') return tab === 'logs' ? 'logs' : 'orquestrador';
  if (secao === 'gerenciar-logs') return 'logs';
  return secao ?? 'bots';
};

export const AutomacaoPage = () => {
  const [searchParams] = useSearchParams();
  const destino = resolveSecao(searchParams.get('secao'), searchParams.get('tab'));
  const [indice, setIndice] = useState(Math.max(0, ABAS.indexOf(destino)));

  // Bookmark de aba de acompanhamento antiga: a leitura agora e no /orquestrador.
  if (destino === 'orquestrador') {
    return <Navigate to="/orquestrador" replace />;
  }

  return (
    <Box p={6}>
      <VStack align="stretch" spacing={1} mb={5}>
        <Heading size="lg">Automação</Heading>
        <Text color="gray.600" fontSize="sm">
          Cadastro, credenciais e logs dos bots.
        </Text>
      </VStack>

      <Tabs index={indice} onChange={setIndice} colorScheme="blue" isLazy>
        <TabList>
          <Tab>Bots</Tab>
          <Tab>Logs</Tab>
        </TabList>

        <TabPanels>
          <TabPanel px={0}>
            <BotsTab />
          </TabPanel>

          <TabPanel px={0}>
            <LogsBrowserView />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Box>
  );
};

export default AutomacaoPage;
